import { capitalize } from 'lodash';
import { CircleOff } from 'lucide-react';

import { Heading } from '@/components/heading';
import { Text } from '@/components/text';

export interface RouteNoModeResultProps {
  title: string;
}

const RouteNoModeResult = ({ title }: RouteNoModeResultProps) => {
  return (
    <div className="mb-6">
      <Heading variant="h4" as="h2" className="mb-1.5 text-baseSm text-text-primary">
        {capitalize(title)}
      </Heading>
      <div className="md:-mx-2">
        <div className="flex items-center gap-2 border border-grey-200 bg-grey-50 p-4 text-baseSm italic text-grey-500 md:rounded-md md:border">
          <CircleOff className="size-4" />
          <Text variant="sm" className="m-0 italic text-grey-600">
            No viable {title} found between the origin and destination based on the criteria supplied
          </Text>
        </div>
      </div>
    </div>
  );
};

export { RouteNoModeResult };
